exports.default = {
  'basic_info': '基礎信息',
  'team_avatar': '團隊頭像',
  'edit_avatar': '修改頭像',
  'team_name': '團隊名稱',
  'edit_team_name': '編輯團隊名稱',
  'team_name_required': '請輸入團隊名稱',
  'team_description': '團隊介紹',
  'save': '保存',
  'save_success': '保存成功！',
  'payment_info': '付費信息',
  'team_benefits': '團隊權益',
  'version_info': '版本信息',
  'team_id': '團隊ID',
  'owner': '所有者',
  'member_seats': '成員數/席位數',
  'team_remaining_points': '團隊剩餘積分',
  'member_count': '{count} 位成員,已刪除成員和待激活成員不佔用名額',
  'creation_time': '創建時間',
  'creation_time_format': '{y}年{m}月{d}日',
  'more_operations': '更多操作',
  'join_approval': '加入審核',
  'join_approval_desc': '開啟後，成員加入團隊需要團隊管理員或超管審核',
  'transfer_team': '移交團隊',
  'transfer_team_desc': '每個團隊只有1位所有者，移交後你將變為普通成員',
  'transfer': '移交',
  'dissolve_team': '解散團隊',
  'dissolve_team_desc': '解散後，團隊內所有內容都會被徹底刪除不可恢復，請謹慎操作',
  'dissolve': '解散',
  'crop_image': '裁剪圖片',
  'crop_image_question': '是否需要裁剪圖片？',
  'crop': '裁剪',
  'upload_without_crop': '不裁剪直接上傳',
  'upload_image': '上傳圖片',
  'cancel': '取 消',
  'confirm': '確 定',
  'team_transfer': '團隊轉移',
  'user': '用戶',
  'phone': '手機',
  'prompt': '提示',
  'email': '郵箱',
  'join_time': '加入時間',
  'operation': '操作',
  'transfer_btn': '轉移',
  'image_type_error': '圖片類型必須是.gif,jpeg,jpg,png,bmp中的一種',
  'dissolve_team_prompt': '一旦你解散了團隊，團隊內所有智能體、項目文檔、以及部門成員都將會被永久刪除。這是一個不可恢復的操作，請謹慎對待！',
  'dissolve_team_title': '解散團隊',
  'dissolve_team_input_placeholder': '請輸入"DELETE"以確認',
  'dissolve_team_input_error': '請輸入"DELETE"以確認',
  'transfer_team_confirm': '轉移團隊後您將成為團隊普通成員！確定轉移？',
  'transfer_team_confirm_title': '提示',
  'member': '成員',
  'department': '部門',
  'leave_member': '離職成員',
  'waiting_approval': '等待審批',
  'already_joined': '已加入',
  'add_sub_department': '添加子部門',
  'edit': '編輯',
  'move_up': '上移',
  'move_down': '下移',
  'delete': '刪除',
  'search_name_phone_email': '姓名、手機、郵箱',
  'create_department': '新建部門',
  'mark_as_leaving': '操作離職',
  'change_department': '變更部門',
  'invite_members': '邀請成員',
  'name': '姓名',
  'edit_department': '編輯部門',
  'parent_department': '上級部門',
  'department_name': '部門名稱',
  'department_name_required': '請輸入部門名稱',
  'get_department_list_failed': '獲取部門列表失敗',
  'add_department_failed': '添加部門失敗',
  'edit_department_failed': '修改部門失敗',
  'department_setting': '變更部門',
  'team_invitation': '團隊邀請',
  'confirm_remove_member': '確定將該成員移除？',
  'tips': '提示',
  'executing': '執行中...',
  'operation_success': '操作成功！',
  'select_departments_to_change': '請先勾選要變更的成員',
  'protected_member_cannot_leave': '所有者和目前使用者不能操作離職',
  'contains_protected_member': '所選成員包含所有者或目前使用者，不能操作離職',
  'select_members_to_leave': '請先勾選要離職的成員',
  'select_members_to_operate': '請先勾選要操作的成員',
  'restore': '恢復',
  'clear': '清空',
  'previous_department': '離職前所屬部門',
  'days_since_leaving': '離職天數',
  'leaving_date': '離職日期',
  'confirm_restore': '確定恢復成員?',
  'confirm_delete': '確定刪除?',
  'confirm_clear': '確定清空?',
  'select_members_first': '請先勾選要操作的數據',
  'confirm_restore_member': '確定恢復成員?',
  'pass': '通過',
  'reject': '拒絕',
  'confirm_approve': '確定同意加入企業？',
  'confirm_reject': '確定拒絕加入企業？',
  'enter_department_name': '請輸入部門名稱',
  'batch_delete': '批量刪除',
  'batch_edit': '批量編輯',
  'department_members': '部門人數',
  'department_member_count': '部門成員數',
  'department_manager': '負責人',
  'confirm_delete_department': '確定刪除部門？',
  'already_highest_level': '已是最高一級了',
  'already_the_top_level': '已是最高一級了',
  'leave_date': '離職日期',
  'department_has_members': '部門或子部門中存在成員，無法刪除',
  'already_top_level': '已是最高一級了',
  'select_departments_first': '請先勾選要刪除的部門',
  'delete_child_first': '請先刪除所有子部門再進行刪除部門操作。',
  'select_departments_to_edit': '請先勾選要編輯的部門',
  'roles': '角色',
  'member_roles': '成員角色',
  'role_management': '角色管理',
  'role_authorization': '角色功能授權',
  'authorize_role': '功能授權',
  'no_authorization_items': '暫無可授權的團隊管理功能',
  'create_role': '新建角色',
  'edit_role': '編輯角色',
  'role_name': '角色名稱',
  'role_name_required': '請輸入角色名稱',
  'confirm_delete_role': '確定刪除該角色？',
  'member_roles_and_limits': '成員角色與額度',
  'limit_management': '限額管理',
  'limit_management_desc': '為團隊成員設置積分使用限額',
  'limit_status': '限額狀態',
  'limit_enabled': '已啟用',
  'limit_disabled': '不限額',
  'authorized_limit': '授權額度',
  'remaining_limit': '剩餘額度',
  'assign_roles': '分配角色',
  'member_limit': '成員額度',
  'set_member_limit': '設置額度',
  'unlimited': '不限額',
  'enable_member_limit': '啟用成員積分限額',
  'limit_adjustment': '本次額度調整',
  'current_authorized': '當前累計授權',
  'after_adjustment': '調整後累計授權',
  'adjust_member_limit': '調整額度',
  'limit_adjustment_description': '選擇操作模式並輸入積分數量',
  'limit_adjustment_mode': '模式',
  'limit_adjustment_add': '添加',
  'limit_adjustment_reduce': '減少',
  'limit_adjustment_points': '數量（積分）',
  'used_points': '已使用積分',
  'remaining_after_adjustment': '調整後剩餘額度',
  'limit_reduction_max': '最多可減少 {max} 積分，僅可減少未使用額度',
  'invalid_points_amount': '請輸入有效的非負整數積分',
  'remaining_limit_nonnegative': '調整後剩餘額度不能小於 0，請增加額度後再確認',
  'enable_limit_base_hint': '開啟限額時，以已使用積分作為授權基準，新增積分即為可用額度',
  'consumption_records': '消費記錄',
  'points_ledger_desc': '查看當前團隊下的積分獲取、消費、過期和調整記錄',
  'points_event': '積分事件',
  'occurred_at': '發生時間',
  'points_change': '積分變化',
  'points_balance': '剩餘積分',
  'points_earned': '獲取積分',
  'points_expired': '積分過期',
  'points_adjusted': '積分調整',
  'points_consumption': '積分消費',
  'agent_task': 'Agent任務',
  'expand_details': '展開明細',
  'collapse_details': '收起明細',
  'no_points_records': '暫無積分流水記錄',
  'load_points_records_failed': '加載積分流水失敗',
  'all_team_records': '全團隊記錄',
  'my_team_records': '我的記錄',
  'unknown_member': '未知成員'
}
